<meta name="viewport" content="width=device-width, initial-scale=1.0">

<app-main  [user]="user" [iduser]="iduser"></app-main>
<app-logo></app-logo>